// src/Components/EmailComposer.js

import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Dialog, DialogContent } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import QuillEmailEditor from './QuillEmailEditor';
import { useDispatch, useSelector } from 'react-redux';
import { sendEmail,cancelCompose } from '../../slices/emailSlice';
import { replaceBase64Images } from '../../utils/replaceBase64Images';
import useMediaQuery from '@mui/material/useMediaQuery';
import parse from 'html-react-parser'

import '../../css/EmailComposer.css'
import {getTemplate, getUserEmailTemplates} from '../../APIS/emailAPI.js'

const cssheaders = `
<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Carlito:ital,wght@0,400;0,700;1,400;1,700&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap" rel="stylesheet">
<link rel="stylesheet" href="https://www.ttpadvisory.co.uk/css/ttpemail.css" >
`

const EmailComposer = ({  onSent }) => {
  const dispatch = useDispatch();
  const [to, setTo] = useState("");
  const [cc,setCc] = useState("")
  const [bcc,setBcc] = useState("")
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [inithtml,setInitialHtml]=useState("")
  const [preview,setPreview] = useState(false)
  const [emailFooter, setEmailFooter] = useState("")
  const [includeFooter,setIncludeFooter] = useState(true)
  const [templates,setTemplates] = useState([])
  const [selectedTemplate,setSelectedTemplate] = useState("")
  const [attachments, setAttachments] = useState([]);

  const isMobile = useMediaQuery('(max-width:768px)');
  const email = useSelector((state) =>state.auth.email);
  const name = useSelector((state) =>state.auth.name);
  const phone = useSelector((state) =>state.auth.phone);
  const jobtitle = useSelector((state) =>state.auth.jobtitle);
  const token =  useSelector((state) =>state.auth.token);
  const rowdata = useSelector((state) =>state.data.rowdata);

  const [refreshheaders,updateHeaders] = useState(false)

    // Get the Email footer for this user.
    useEffect(() => {
      async function getData() {
        const user = {name,email,phone,jobtitle}
        const template = await getTemplate(token, "blank", user, {})
        if(template.status) {
              setEmailFooter(template.data.email)
              setSubject("")
        }else {
          setEmailFooter("");
          setSubject("");
        }
        const templist = await getUserEmailTemplates(token);
        if(templist.status)
          setTemplates(templist.data)
        else setTemplates([])

        if((rowdata.Email??"") > "")
          setTo(rowdata.Email??"")
      }
      getData();
    },[refreshheaders])

    const handleSend = async () => {
        if (!to || !subject || !body) {
            alert('Please complete all fields before sending.');
            return;
        }
        let emailbody = `<link rel="stylesheet" href="https://www.ttpadvisory.co.uk/css/ttpemail.css" >\n${body}`;
        if(includeFooter)
          emailbody = `<link rel="stylesheet" href="https://www.ttpadvisory.co.uk/css/ttpemail.css" >\n${body}<p></p><p></p>${emailFooter}`
        dispatch(sendEmail({ to, subject, body: emailbody, attachments}))
        dispatch(cancelCompose());
        setTo("");
        setSubject("");
  };

  const handleCancel = () => {
    if(body > "") {
      if(window.confirm("You have text in your email. If you cancel you will lose the email text. Are you Sure you wish to Cancel?") )
        dispatch(cancelCompose());
    }else
      dispatch(cancelCompose());
  };

  const updateIncludeFooter = (e) => {
    setIncludeFooter(e.target.checked)
  }

  const selectTemplate = async (e) => {
    const templatename = e.target.value
    setSelectedTemplate(templatename)
    if(body > "") {
      if(!window.confirm("You have text in your email. If you Select this Template you will lose the email text. Are you Sure you wish to Do this?") )
        return
    }
    if(templatename === "") {
      setInitialHtml("");
      return;
    }

    const user = {name,email,phone,jobtitle}
    const template = await getTemplate(token, templatename, user, rowdata)
    if(template.status) {
      setInitialHtml(template.data.email)
      setSubject(template.data.subject)
    }
  }

  // Handle Attachments
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    const encodedFiles = await Promise.all(
      files.map(async (file) => {
        const base64 = await fileToBase64(file);
        return {
          filename: file.name,
          content: base64.split(',')[1], // Remove data:...;base64,
          contentType: file.type,
        };
      })
    );
    setAttachments(encodedFiles);
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  };



  return (
  <>
    <Dialog
          fullWidth={false}
          maxWidth='xl'
          open={preview}
          onClose={() => setPreview(false)}
          sx={{maxWidth: 850, height: 700, marginLeft: 'auto', marginRight: 'auto'}}
    >
      <DialogContent>
        {parse(cssheaders)}
        {parse(body)}<br/>
        {includeFooter && parse(emailFooter)}
      </DialogContent>
      <Button onClick={() => setPreview(false) }>Close</Button>
    </Dialog>
    <div style={{ display: 'block', maxWidth: isMobile?600:1024 }}>
      <h4>Compose Email <input type='checkbox' onClick={()=>updateHeaders((state) => !state)} /></h4>

      <span className='addrlabel'>To</span><input className='addrfield'
        id='to'
        value={to}
        onChange={(e) => setTo(e.target.value)}
      /><br/>
      <span className='addrlabel'>Cc</span><input className='addrfield'
        id='cc'
        value={cc}
        onChange={(e) => setCc(e.target.value)}
      /><br/>
      <span className='addrlabel'>Bcc</span><input className='addrfield'
        id='bcc'
        value={bcc}
        onChange={(e) => setBcc(e.target.value)}
        style={{lineHeight: '10pt', fontSize: '10pt', padding: 0}}
      /><br/>
      <span className='addrlabel'>Subject</span><input className='addrfield'
        id='subject'
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        style={{lineHeight: '10pt', fontSize: '10pt', padding: 0}}
      /><br/>
      <span className='addrlabel'>Attachments</span><input type="file"  multiple onChange={handleFileChange} style={{lineHeight: '10pt',marginBottom: '10px', fontSize: '10pt', padding: 0}} /><br/>

      <span className='addrlabel'>Template</span><select id='templatelist' name='templatelist' onChange={selectTemplate} style={{lineHeight: '10pt', fontSize: '10pt', padding: 0}}>
        <option value="">Blank Email</option>
        {templates.map(item => {
          if(item.name === selectedTemplate)
            return (<option value={item.name} selected >{item.description}</option>)
          return (<option value={item.name} >{item.description}</option>)

          })}
      </select>
      <div style={{display: 'inline-block', float: 'right'}}>
        <input type='button' className='btns' onClick={handleSend} value="Send"/>&nbsp;
        <input type='button' className='btns'  onClick={handleCancel} value="Cancel" />&nbsp;
        <input type='button' className='btns' onClick={()=>setPreview(true)} value="Preview"/>&nbsp;
      </div>
      <br/>
      <div style={{ marginBottom: 10, clear: 'both' }}>
        <QuillEmailEditor value={inithtml} onChange={setBody}  />
        Include Footer <input type='checkbox' checked={includeFooter}  onClick={updateIncludeFooter} /><br/>
        {includeFooter &&
          <div style={{maxWidth: isMobile?600:1024, border: '1px solid: #ccc', height: '200px', overflowY: 'auto' }}>
          Footer<br/>
          {parse(cssheaders)}
          {parse(emailFooter)}
          </div>
        }
      </div>

    </div>
    </>
  );
};

export default EmailComposer;
